module.exports = __webpack_public_path__ + "static/media/external-link-alt.4b6aa08a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/external-link-alt.svg
// module id = 535
// module chunks = 0